import {
  useAppDispatch,
  useAppSelector,
  useState,
} from "@/utils/hooks/reactUseCustomHooks";
import {
  addFavouritesRecipes,
} from "@/utils/redux/recipes/recipeSlice/actions";
import { setToastMessage } from "@/utils/redux/recipes/toastMessageSlice";
import useNetwork from "./useNetwork";
import { useGigyaToken } from "./getGigyaToken";
import { deleteCookie, getCookie } from "cookies-next";
import { algolia } from "@/services/algolia";
import { algoliaConfig } from "@/services/algolia/config";
import { useGigyaAccountInfo } from "@/helpers/gigyaCentralSsoHook";
import { setFavourites } from "@/utils/redux/recipes/addtolistSlice";
import { mealPlanDefautMessage } from "@/utils/aemDefaultData";

const useFavorites = () => {
  const { uid: Uid } = useAppSelector((state) => state.gigyaslice);
  // const { favourite }: any = useAppSelector(
  //   (state) => state.favouritesRecipeSlice
  // );
  const { favourite } = useAppSelector((state) => state.RecipeToList);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFavourite, setIsFavourite] = useState(false);
  const [favLoading, setFavLoading] = useState(false);
  const dispatch = useAppDispatch();
  const isOnline = useNetwork();
  const { resetLoginParams } = useGigyaToken();
  const { messages: MESSAGE } = useAppSelector((state) => state.messageSlice);
  const gigyaToken = useGigyaAccountInfo();

  // const getRecipeList = async (Uid: any) => {
  //   try {
  //     const { idToken: token } = await gigyaToken();
  //     const result = await dispatch(getRecipeListAction({ token }));
  //     if (result?.payload?.status == 401) {
  //       console.log("session timeout");
  //     }
  //     return result;
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };
  const addToFavorite = async (item: any, isFavourite?: boolean) => {
    /** Check if User is online */
    if (!isOnline) {
      dispatch(
        setToastMessage({
          message: `${MESSAGE?.ERROR_MESSAGE?.OFFLINE_ERROR ?? mealPlanDefautMessage[0]?.offlineError}`,
          status: "favouriteMessage",
          color: "error",
        })
      );
      return;
    }
    if (Uid) {
      try {
        setFavLoading(true);
        setIsModalOpen(true);
        const { idToken: token } = await gigyaToken();

        if (!favourite?.id) {
          return;
        }
        const payload = {
          recipe_id: item.objectID,
          list_id: favourite.id,
          token,
        };
        const fav = await dispatch(addFavouritesRecipes(payload));
        if (fav?.payload?.status == 401) {
          void resetLoginParams();
          return;
        }
        if (fav?.payload?.message === "added") {
          dispatch(
            setFavourites({
              ...favourite,
              recipes: [...favourite.recipes, { recipe_id: item.objectID }],
            })
          );
          dispatch(
            setToastMessage({
              message: `${MESSAGE?.FAVOURITE_RECIPE_ADDED ?? mealPlanDefautMessage[0]?.favouriteRecipeAdded}`,
              status: "favouriteMessage",
            })
          );
          setFavLoading(false);
        } else if (fav?.payload?.message === "removed") {
          dispatch(
            setFavourites({
              ...favourite,
              recipes: favourite.recipes.filter(
                (recipe: any) => recipe.recipe_id !== item.objectID
              ),
            })
          );
          dispatch(
            setToastMessage({
              message: `${MESSAGE?.FAVOURITE_RECIPE_REMOVED ?? mealPlanDefautMessage[0]?.favouriteRecipeRemoved}`,
              status: "favouriteMessage",
            })
          );
          setFavLoading(false);
        } else {
          dispatch(
            setToastMessage({
              message: `Something went wrong`,
              status: "favouriteMessage",
              color: "error",
            })
          );
          setIsModalOpen(false);
          setFavLoading(false);
        }
        // const result = await dispatch(getfetchFavouritesRecipes({ token }));
      } catch (error) {
        console.error("Failed to update favourites:", error);
      }
    }
  };

  const saveToFavorite = async (recipeId: any) => {
    let modelOpen = true;
    setFavLoading(true);
    setIsModalOpen(true);
    deleteCookie("susfvd");
    if (!isOnline) {
      dispatch(
        setToastMessage({
          message: `${MESSAGE?.ERROR_MESSAGE?.OFFLINE_ERROR ?? mealPlanDefautMessage[0]?.offlineError}`,
          status: "favouriteMessage",
          color: "error",
        })
      );
      return;
    }
    if (Uid && recipeId && favourite.id) {
      setFavLoading(true);
      try {
        const { idToken: token } = await gigyaToken();
        // const data = await getRecipeList(Uid);
        const payload = {
          recipe_id: recipeId,
          list_id: favourite.id,
          token,
        };
        const fav = await dispatch(addFavouritesRecipes(payload));
        if (fav?.payload?.status == 401) {
          resetLoginParams();
          return;
        }
        if (fav?.payload?.message === "added") {
          dispatch(
            setFavourites({
              ...favourite,
              recipes: [...favourite.recipes, { recipe_id: recipeId }],
            })
          );
          dispatch(
            setToastMessage({
              message: `${MESSAGE?.FAVOURITE_RECIPE_ADDED ?? mealPlanDefautMessage[0]?.favouriteRecipeAdded}`,
              status: "favouriteMessage",
            })
          );
          setFavLoading(false);
        } else if (fav?.payload?.message === "removed") {
          dispatch(
            setFavourites({
              ...favourite,
              recipes: favourite.recipes.filter(
                (recipe: any) => recipe.recipe_id !== recipeId
              ),
            })
          );
          dispatch(
            setToastMessage({
              message: `${MESSAGE?.FAVOURITE_RECIPE_REMOVED ?? mealPlanDefautMessage[0]?.favouriteRecipeRemoved}`,
              status: "favouriteMessage",
            })
          );
          setFavLoading(false);
        } else {
          dispatch(
            setToastMessage({
              message: `Something went wrong`,
              status: "favouriteMessage",
              color: "error",
            })
          );
          setIsModalOpen(false);
          setFavLoading(false);
          modelOpen = false;
        }
        // const result = await dispatch(getfetchFavouritesRecipes({ token }));
        return modelOpen;
      } catch (error) {
        console.error("Failed to update favourites:", error);
      }
    }
  };
  // helpers.ts (or in the same file if it's not reused elsewhere)
  const afterLoginAddToFav = async ({
    hasRunRef,
    setOpenFavModal,
    setFavItem,
  }: {
    hasRunRef: React.MutableRefObject<boolean>;
    setOpenFavModal: (val: boolean) => void;
    setFavItem: (val: any) => void;
  }) => {
    const rawValue = await getCookie("susfvd");
    const recipeId: any = rawValue ? getParsedCookieValue(rawValue) : "";
    if (hasRunRef.current) return;
    if (!recipeId || !Uid || !favourite?.id) return;

    try {
      if (recipeId) {
        hasRunRef.current = true;
        const modelOpen: any = saveToFavorite(recipeId);

        if (modelOpen) {
          setOpenFavModal(true);

          try {
            const recipeFavItem = await algolia.getObjectDetail({
              objectID: recipeId,
              indexName: algoliaConfig.indexNames.recipes,
            });
            setFavItem(recipeFavItem);
          } catch (err) {
            console.error("Algolia fetch failed:", err);
          }
          deleteCookie("susfvd");
        }
      }
    } catch (error) {
      void deleteCookie("susfvd");
      console.error("Failed to parse susfvd cookie:", error);
    }
  };

  const toggleFavourite = () => setIsFavourite(!isFavourite);

  const openFavourite = () => {
    if (favourite?.recipes) {
      setIsFavourite(true);
    }
  };
  const closeFavourite = () => setIsFavourite(false);

  const stopFavLoading = () => setFavLoading(false);

  const afterLoginAddToMealPlan = async ({
    loginStates,
  }: {
    loginStates?: any;
  }) => {
    const rawValue = await getCookie("susmp");
    const recipeId: any = rawValue ? getParsedCookieValue(rawValue) : "";
    if (!recipeId || !Uid) return;
    try {
      const recipeMealPlanItem = await algolia.getObjectDetail({
        objectID: recipeId,
        indexName: algoliaConfig.indexNames.recipes,
      });
      await loginStates(recipeMealPlanItem);
      setTimeout(() => {
        deleteCookie("susmp");
      }, 400);
    } catch (error) {
      console.error("Failed to parse susmp cookie:", error);
    }
  };

  /**
   * Safely gets a string value from a cookie that may be JSON-encoded.
   * Handles raw strings, stringified strings, or stringified objects.
   */
  function getParsedCookieValue(
    rawValue: string | null,
    fallbackKey?: string
  ): string | null {
    if (!rawValue) return null;

    try {
      const decoded = decodeURIComponent(rawValue);
      const parsed = JSON.parse(decoded);

      if (typeof parsed === "string") return parsed;
      if (typeof parsed === "number") return String(parsed);
      if (typeof parsed === "object" && fallbackKey && parsed[fallbackKey]) {
        return String(parsed[fallbackKey]);
      }

      return null;
    } catch {
      return rawValue;
    }
  }

  return {
    addToFavorite,
    saveToFavorite,
    isModalOpen,
    setIsModalOpen,
    isFavourite,
    setIsFavourite,
    toggleFavourite,
    openFavourite,
    closeFavourite,
    favLoading,
    afterLoginAddToFav,
    afterLoginAddToMealPlan,
  };
};
export default useFavorites;
